import '../../../../@ant-design/cssinjs/es/extractStyle.js';
import '../../../../@ant-design/cssinjs/es/hooks/useCacheToken.js';
import '../../../../rc-util/es/Dom/dynamicCSS.js';
import 'react';
import '../../../../@ant-design/cssinjs/es/StyleContext.js';
import { unit } from '../../../../@ant-design/cssinjs/es/util/index.js';
import '../../../../@ant-design/cssinjs/es/hooks/useCompatibleInsertionEffect.js';
import '../../../../@ant-design/cssinjs/es/hooks/useEffectCleanupRegister.js';
import '../../../../@ant-design/cssinjs/es/hooks/useHMR.js';
import '../../../../@emotion/unitless/dist/unitless.cjs.js';
import '../../../../stylis/dist/umd/stylis.js';
import '../../../../rc-util/es/warning.js';
import '../../../../@ant-design/cssinjs/es/theme/createTheme.js';
import '../../../../@ant-design/cssinjs/es/theme/ThemeCache.js';
import '../../../../@ant-design/cssinjs/es/transformers/legacyLogicalProperties.js';
const genStickyStyle = token => {
  const {
    componentCls,
    opacityLoading,
    tableScrollThumbBg,
    tableScrollThumbBgHover,
    tableScrollThumbSize,
    tableScrollBg,
    zIndexTableSticky,
    stickyScrollBarBorderRadius,
    lineWidth,
    lineType,
    tableBorderColor
  } = token;
  const tableBorder = `${unit(lineWidth)} ${lineType} ${tableBorderColor}`;
  return {
    [`${componentCls}-wrapper`]: {
      [`${componentCls}-sticky`]: {
        '&-holder': {
          position: 'sticky',
          zIndex: zIndexTableSticky,
          background: token.colorBgContainer
        },
        '&-scroll': {
          position: 'sticky',
          bottom: 0,
          height: `${unit(tableScrollThumbSize)} !important`,
          zIndex: zIndexTableSticky,
          display: 'flex',
          alignItems: 'center',
          background: tableScrollBg,
          borderTop: tableBorder,
          opacity: opacityLoading,
          '&:hover': {
            transformOrigin: 'center bottom'
          },
          // fake scrollbar style of sticky
          '&-bar': {
            height: tableScrollThumbSize,
            backgroundColor: tableScrollThumbBg,
            borderRadius: stickyScrollBarBorderRadius,
            transition: `all ${token.motionDurationSlow}, transform none`,
            position: 'absolute',
            bottom: 0,
            '&:hover, &-active': {
              backgroundColor: tableScrollThumbBgHover
            }
          }
        }
      }
    }
  };
};
var genStickyStyle$1 = genStickyStyle;
export { genStickyStyle$1 as default };
//# sourceMappingURL=sticky.js.map
